"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The RfqLinePartDetail model module.
 * @module model/RfqLinePartDetail
 * @version 0.0.1
 */
var RfqLinePartDetail = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>RfqLinePartDetail</code>.
   * @alias module:model/RfqLinePartDetail
   */
  function RfqLinePartDetail() {
    _classCallCheck(this, RfqLinePartDetail);
    RfqLinePartDetail.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(RfqLinePartDetail, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>RfqLinePartDetail</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/RfqLinePartDetail} obj Optional instance to populate.
     * @return {module:model/RfqLinePartDetail} The populated <code>RfqLinePartDetail</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new RfqLinePartDetail();
        if (data.hasOwnProperty('part_entity_leaf_id')) {
          obj['part_entity_leaf_id'] = _ApiClient["default"].convertToType(data['part_entity_leaf_id'], 'Number');
        }
        if (data.hasOwnProperty('part_number')) {
          obj['part_number'] = _ApiClient["default"].convertToType(data['part_number'], 'String');
        }
        if (data.hasOwnProperty('weight_per_uom')) {
          obj['weight_per_uom'] = _ApiClient["default"].convertToType(data['weight_per_uom'], 'Number');
        }
        if (data.hasOwnProperty('height')) {
          obj['height'] = _ApiClient["default"].convertToType(data['height'], 'Number');
        }
        if (data.hasOwnProperty('width')) {
          obj['width'] = _ApiClient["default"].convertToType(data['width'], 'Number');
        }
        if (data.hasOwnProperty('length')) {
          obj['length'] = _ApiClient["default"].convertToType(data['length'], 'Number');
        }
      }
      return obj;
    }
  }]);
}();
/**
 * @member {Number} part_entity_leaf_id
 */
RfqLinePartDetail.prototype['part_entity_leaf_id'] = undefined;

/**
 * @member {String} part_number
 */
RfqLinePartDetail.prototype['part_number'] = undefined;

/**
 * @member {Number} weight_per_uom
 */
RfqLinePartDetail.prototype['weight_per_uom'] = undefined;

/**
 * @member {Number} height
 */
RfqLinePartDetail.prototype['height'] = undefined;

/**
 * @member {Number} width
 */
RfqLinePartDetail.prototype['width'] = undefined;

/**
 * @member {Number} length
 */
RfqLinePartDetail.prototype['length'] = undefined;
var _default = exports["default"] = RfqLinePartDetail;